/**
 * `company` - the register's facts (name, industry) for the best organisation
 * number found so far, through the runner's `companyLookup` port.
 *
 * Needs `candidates:orgNumber` and the `company-lookup` port. Provides
 * `company`. No options. Usually optional: a reading goes on without it.
 */

import type { Step } from '../types.js';

export const companyStep: Step<Record<string, never>> = {
  name: 'company',
  needs: () => ['candidates:orgNumber', 'company-lookup'],
  provides: () => ['company'],
  async run(state, context) {
    const lookup = context.ports.companyLookup;
    if (!lookup) return { skipped: 'no company lookup' };
    const best = [...(state.candidates.orgNumber ?? [])]
      .filter((candidate) => typeof candidate.value === 'string')
      .sort((a, b) => (b.confidence ?? 0) - (a.confidence ?? 0))[0];
    if (!best) return { skipped: 'no organisation number' };
    const company = await lookup(best.value as string);
    if (!company) return { skipped: `${String(best.value)} not in the register` };
    return { company, added: [`${company.name}${company.industry ? ` · ${company.industry}` : ''}`] };
  },
};
